import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AudioPlayerComponent } from './audio-player.component';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';



@NgModule({
  declarations: [
    AudioPlayerComponent
  ],
  exports: [
    AudioPlayerComponent,
  ],
  imports: [
    CommonModule,
    FormsModule
    ]
})
export class AudioPlayerModule { }
